import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataguardHeatmap from "../DataguardHeatmap";
import SmallHeatmap from "../SmallHeatmap";
import { GET_USERS_DASHBOARD_DATA } from "../../Utility/DataguardConstant";
import { numFormatter } from "../../../../components/common/Dashboard/utils";
import FullscreenIcon from "@material-ui/icons/Fullscreen";

const UserDataCard = ({
  showExpandedView,
  isPopup = false,
  onClick,
  style,
}) => {
  const dispatch = useDispatch();
  const userDashboardData = useSelector(
    (state) => state.dataTagReducer.userDashboardData,
  );
  const fromTimeStamp = useSelector(
    (state) => state.DataguardReducer.fromTimeStamp,
  );
  const toTimeStamp = useSelector(
    (state) => state.DataguardReducer.toTimeStamp,
  );

  useEffect(() => {
    // Fetch public data assets count when fromTimeStamp or toTimeStamp changes
    if (fromTimeStamp && toTimeStamp) {
      // Dispatch an action to fetch public data assets count
      dispatch({
        type: GET_USERS_DASHBOARD_DATA,
        payload: { fromTimeStamp, toTimeStamp },
      });
    }
  }, [dispatch, fromTimeStamp, toTimeStamp]);

  const totalUsers = userDashboardData?.totalUserCount || 0;

  const totalActivities = userDashboardData?.totalActivities || 0;

  const totalUniqueFiles = userDashboardData?.totalUniqueFiles || 0;

  const formattedTotalUsers = totalUsers.toLocaleString("en-US");
  const formattedTotalActivities = totalActivities.toLocaleString("en-US");
  const formattedTotalUniqueFiles = totalUniqueFiles.toLocaleString("en-US");

  return (
    <div className="column-card public-data-card" style={style}>
      <div className="details-container" onClick={onClick}>
        <div className="left-details">
          <div className="left-details-container public">
            <div className="icon-container">
              <img src="/dataguardIcons/roles.svg" alt="Location Icon" />
              <span className="ico-label">Users</span>
            </div>
            <div className="left-details-txt">
              <span>Total # of Users</span>
              <span className="no-locs">
                {numFormatter(formattedTotalUsers || 0)}
              </span>
            </div>

            <div className="left-details-txt">
              <span>Total # of Activities</span>
              <span className="loc-alert">
                {numFormatter(formattedTotalActivities || 0)}
              </span>
            </div>

            <div className="left-details-txt">
              <span>Total # of Unique Files</span>
              <span className="loc-alert">
                {numFormatter(formattedTotalUniqueFiles || 0)}
              </span>
            </div>
          </div>
        </div>
        <div className="right-chart">
          <DataguardHeatmap loc={isPopup ? "dashboardPopup" : "default"} />
        </div>
      </div>
      {!isPopup ? (
        <div
          className="fullscreen-icon roles"
          onClick={(e) => {
            showExpandedView("heatMap");
            e.stopPropagation();
          }}
        >
          <FullscreenIcon fontSize="small" />
        </div>
      ) : null}
    </div>
  );
};

export default UserDataCard;